<template>
  <div>
    <v-data-table :headers="modeConfig.headers" :items="filteredItems"
      :item-value="(isType) ? 'type_name' : 'tag_name'" class="elevation-1" :items-per-page-options="[5, 10, 15, 20]">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ modeConfig.title+" Settings" }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-btn color="green" @click="openCreationDialog">Create New</v-btn>
          <v-select
         v-if="isTag && !['/conversation', '/frontdesk', '/labCases'].includes($route.path)"
            v-model="selectedTagSource"
            :items="['tags', 'convoTags', 'osclaimsTags', 'OSclaimsconvoTags', 'allTags']"
            label="Select Tag Type"
            class="ml-4"
            dense
            hide-details
            style="max-width: 200px"
          ></v-select>

          <v-spacer></v-spacer>
          <v-icon v-if="$route.path != '/settings'" color="red" @click="closeTypeTagSettings">mdi-close</v-icon>
        </v-toolbar>
      </template>

      <!-- Tags -->
      <template v-slot:item.tag_name="{ item }" v-if="isTag">
        <div @click.prevent="editOrDeleteTag(item)"
          style="margin-left: 8px; text-decoration: none; color: black; cursor: pointer;">
          {{ item.tag_name }}
        </div>
      </template>

      <template v-slot:item.tag_desc="{ item }" v-if="isTag">
        <div @click.prevent="editOrDeleteTag(item)"
          style="margin-left: 8px; text-decoration: none; color: black; cursor: pointer;">
          {{ item.tag_desc }}
        </div>
      </template>

      <template v-slot:item.tag_icon="{ item }" v-if="isTag">
        <div @click.prevent="editOrDeleteTag(item)"
          style="margin-left: 8px; cursor: pointer;">
          <v-icon :color="item.tag_color">mdi-{{ item.tag_icon }}</v-icon>
        </div>
      </template>

      <template v-slot:item.enable_auto="{ item }" v-if="isTag">
        <v-switch v-model="item.enable_auto" color="success" @click="updateTagSwitch(item, 'enable_auto')"></v-switch>
      </template>

      <template v-slot:item.unlist="{ item }" v-if="isTag">
        <v-switch v-model="item.unlist" color="red" @click="updateTagSwitch(item, 'unlist')"></v-switch>
      </template>

      <!-- Contact Types -->
      <template v-slot:item.type_name="{ item }" v-if="isType">
        <div @click.prevent="editOrDeleteType(item)"
          style="margin-left: 8px; text-decoration: none; color: black; cursor: pointer;">
          {{ item.type_name }}
        </div>
      </template>

      <template v-slot:item.type_desc="{ item }" v-if="isType">
        <div @click.prevent="editOrDeleteType(item)"
          style="margin-left: 8px; text-decoration: none; color: black;cursor: pointer;">
          {{ item.type_desc }}
        </div>
      </template>

      <template v-slot:item.color="{ item }" v-if="isType">
        <v-avatar
            rounded="lg"
            size="x-small"
            :color="item.color"
            @click.prevent="editOrDeleteType(item)"
            >
            <v-btn icon size="x-small" variant="text" >
                <v-icon>mdi-account-outline</v-icon>
              </v-btn>
            </v-avatar>
      </template>

      <template v-slot:item.can_be_set="{ item }" v-if="isType">
        <v-checkbox  v-model="item.can_be_set" color="success" @click="updateTypeSwitch(item, 'can_be_set')"></v-checkbox >
      </template>

      <template v-slot:item.can_be_changed="{ item }" v-if="isType">
        <v-checkbox  v-model="item.can_be_changed" color="success" @click="updateTypeSwitch(item, 'can_be_changed')"></v-checkbox >
      </template>

      <!-- Message Templates -->
      <template v-slot:item.title="{ item }" v-if="isMessageTemplate">
        <div @click.prevent="editTemplate(item)"
          style="margin-left: 8px; cursor: pointer;">
          <v-chip  variant="outlined" :color="item.color">{{ item.title }}</v-chip>
        </div>
      </template>

      <template v-slot:item.template="{ item }" v-if="isMessageTemplate">
        <div @click.prevent="editTemplate(item)"
          style="margin-left: 8px; cursor: pointer;">
          {{ item.template }}
        </div>
      </template>

      <template v-slot:item.contact_type_id="{ item }" v-if="isMessageTemplate">
        <div @click.prevent="editTemplate(item)" v-if="item.contact_type_id">
          <v-avatar 
            rounded="lg"
            size="x-small"
            :color="getContactTypeInfo(item.contact_type_id).color"
            >
            <v-btn icon size="x-small" variant="text" >
                <v-icon>mdi-account-outline</v-icon>
                <v-tooltip activator="parent" location="top">{{ getContactTypeInfo(item.contact_type_id).type_name }}</v-tooltip>
              </v-btn>
          </v-avatar>
        </div>
        <span v-else @click="editTemplate(item)">ALL</span>
      </template>
     
       <template v-slot:item.is_active="{ item }" v-if="isMessageTemplate">
        <div style="margin-top: 5%;">
          <v-switch v-model="item.is_active" color="success" @click="toggleTemplateActiveStatus(item)"></v-switch >
        </div>
      </template>

      <template v-slot:item.delete="{ item }" v-if="isMessageTemplate">
        <v-icon v-if="isMessageTemplate" color="red" @click="deleteTemplate(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>

    <!-- Tag create,edit and delete form -->
    <FrontDeskForm v-if="dialog" v-model="dialog" @close="closeDialog" :isEdit="isEdit" :incoming_Tag="localTag"
      :contactType="contactType" :isType="isType" :isTag="isTag" :isMessageTemplate="isMessageTemplate" :messageTemplate="messageTemplate"
      :tagSource="isTag && !isEdit ? selectedTagSource : null" />

  </div>
</template>

<script>
import FrontDeskForm from './FrontDeskForm.vue';
import { mapGetters, mapActions } from "vuex";
export default {
  name: "FrontDeskSettings",
  data: () => ({
    tagHeaders: [
      { title: 'Name', value: 'tag_name', align: 'center' },
      { title: 'Description', value: 'tag_desc', align: 'center' },
      { title: 'Icon', value: 'tag_icon', align: 'center' },
      { title: 'Enable Auto', value: 'enable_auto' },
      { title: 'Block Further Usage', value: 'unlist' },
    ],
    typeHeaders: [
      { title: 'Name', value: 'type_name', align: 'center' },
      { title: 'Description', value: 'type_desc', align: 'center' },
      { title: 'Color', value: 'color', align: 'center' },
      { title: 'Can Set', value: 'can_be_set' },
      { title: 'Can Change', value: 'can_be_changed' }
    ],
    messageTemplateHeaders : [
      { title: 'Title', value: 'title', align: 'center' },
      { title: 'Template', value: 'template', align: 'center' },
      { title: 'Contact Type', value: 'contact_type_id', align: 'center' },
      { title: 'Active', value: 'is_active' },
      { title : '', value : 'delete'}
    ],
    dialog: false,
    isEdit: false,
    localTag: {},
    contactType: {},
    messageTemplate : {},
    selectedTagSource: "allTags",
  }),
  props: {
    isType: { type: Boolean, default: false },
    isTag : { type: Boolean, default: false },
    isMessageTemplate : { type: Boolean, default: false },
    initialTagSource: { type: String, default: null },
  },
  components: { FrontDeskForm },
  computed: {
    ...mapActions("tags", ["getTags"]),
    ...mapGetters("tags", ["tags","convoTags","allTags","osclaimsTags","osclaimsConvoTags"]),
    ...mapActions("people", ["getContactTypes"]),
    ...mapGetters("people", ["contactTypes","getContactTypeInfo"]),
    ...mapActions("frontdesk",["getMessageTemplates"]),
    ...mapGetters("frontdesk",["message_templates"]),

    currentMode() {
      if (this.isTag) return 'tag';
      if (this.isType) return 'type';
      if (this.isMessageTemplate) return 'messageTemplate';
    },

    modeConfig() {
      return {
        tag: {
          headers: this.tagHeaders,
          items: this.allTags,
          title: 'Tag',
        },
        type: {
          headers: this.typeHeaders,
          items: this.contactTypes,
          title: 'Contact Type',
        },
        messageTemplate: {
          headers: this.messageTemplateHeaders,
          items: this.message_templates,
          title: 'Message Template',
        }
      }[this.currentMode];
    },
     filteredItems() {
      if (!this.isTag) return this.modeConfig.items;
      switch (this.selectedTagSource) {
        case "convoTags":
          return this.convoTags;
        case "tags":
          return this.tags;
        case "osclaimsTags":
          return this.osclaimsTags;
        case "OSclaimsconvoTags":
          return this.osclaimsConvoTags;
        default:
          return this.allTags;
      }
    },
  },
  methods: {
    ...mapActions('tags', ["updateTag"]),
    ...mapActions("people",["updateContactType"]),
    ...mapActions("frontdesk",["updateMessageTemplate","deleteMessageTemplate"]),
    openCreationDialog() {
      this.dialog = true;
      this.isEdit = false;
    },

    editOrDeleteTag(item) {
      this.isEdit = true;
      this.localTag ={
        tag_id: item.tag_id,
        tag_name: item.tag_name,
        tag_desc: item.tag_desc,
        tag_source: item.tag_source,     
        tag_Process: item.tag_Process,
        tag_icon: item.tag_icon,
        tag_color: item.tag_color,
        enable_auto: item.enable_auto,
        unlist: item.unlist,
        is_editable: item.is_editable
      };
      this.dialog = true;
    },
    async updateTagSwitch(item, switch_) {
      let tag = {
        tag_name: item.tag_name,
        tag_icon: item.tag_icon,
        tag_color: item.tag_color,
        enable_auto: item.enable_auto,
        unlist: item.unlist
      };
      if (switch_ === 'enable_auto') {

        tag.enable_auto = !tag.enable_auto;
      } else if (switch_ === 'unlist') {

        tag.unlist = !tag.unlist;
      }
      try {
        await this.updateTag({ tag_data: tag, tag_id: item.tag_id });
      } catch (error) {
        console.error(error);
      }
    },
    editOrDeleteType(item) {
      this.isEdit = true;
      this.contactType = item;
      this.dialog = true;
    },
    async updateTypeSwitch(item, switch_) {
      let contact_Type = {
        type_name : item.type_name,
        type_desc : item.type_desc,
        color : item.color,
        can_be_set : item.can_be_set,
        can_be_changed : item.can_be_changed
      }
      if(switch_==='can_be_set'){
        contact_Type.can_be_set = !item.can_be_set;
      }else if(switch_==='can_be_changed'){
        contact_Type.can_be_changed = !item.can_be_changed;
      }
      await this.updateContactType({"contact_Type" : contact_Type, "id" : item.type_id});
    },
    //   Tag add, edit dialog 
    closeDialog() {
      this.dialog = false;
    },
    closeTypeTagSettings() {
      this.$emit('closeTagSettings')
    },
    editTemplate(item){
      this.isEdit = true;
      this.messageTemplate= item;
      this.dialog = true;
    },
    async toggleTemplateActiveStatus(item){
      let template ={
        title : item.title,
        template : item.template,
        color : item.color,
        contact_type_id : item.contact_type_id == 0? null : item.contact_type_id,
        is_active : !item.is_active
      }
      await this.updateMessageTemplate({"data": template, "template_id": item.template_id});
    },
    async deleteTemplate(item){
      if (confirm("Are you sure you want to delete this message template ?")) {
          await this.deleteMessageTemplate(item.template_id);
      }
    }
  },
async created() {
if (this.isTag) {
      if (this.initialTagSource) {
        this.selectedTagSource = this.initialTagSource;
      } else {
        const path = this.$route.path;
        if (path.includes('/frontdesk') || path.includes('/labCases')) {
          this.selectedTagSource = "tags";
        } else if (path.includes('/conversation')) {
          this.selectedTagSource = "convoTags";
        } else if (path.includes('/osclaims')) {
          this.selectedTagSource = "osclaimsTags";
        } else {
          this.selectedTagSource = "allTags";
        }
      }
      await this.getTags;
    }else if( this.isType){
      await this.getContactTypes;
    }else if(this.isMessageTemplate){
      await this.getMessageTemplates;
    }
  }
};
</script>
<style>
.v-data-table thead th {
  font-weight: bold !important;
  /* Make header text bold */
}
</style>